import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${ColorPalette.HEX.Lotion};
    min-height: 100%;
    padding: 40px 16px 16px;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 40px;
  margin-bottom: 16px;
  height: 56px;
`;

export const Content = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: repeat(3, 33%);
    grid-gap: 5px;
  }
`;

export const ErrorValidation = styled.span`
  padding-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.primaryBackgroundColor};
`;

export const WarningContainer = styled.div`
  border-radius: 16px;
  box-shadow: 0 6px 10px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  color: ${ColorPalette.HEX.CharlestonGreen};
  margin-top: 15px;
  margin-bottom: 32px;
  background: ${ColorPalette.HEX.White};

  & img {
    margin-right: 16px;
  }
`;
